var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { width: "100%", height: "100%" },
      attrs: { id: "videoWrap" },
    },
    [
      _c("div", { attrs: { id: "tcView" } }),
      _c("ComponentDialog1", {
        attrs: {
          icon: "fail",
          title: "提示",
          tips: "为了确保您还在观看视频 请点击以继续",
          visible: _vm.fiveMintDialog,
          iconPosition: "center",
          showCancelBtn: false,
          showConfirmBtn: false,
          confirmText: "继续学习",
        },
        on: {
          "update:visible": function ($event) {
            _vm.fiveMintDialog = $event
          },
          confirm: _vm.continues,
        },
      }),
      _c("ComponentDialog1", {
        attrs: {
          icon: "fail",
          title: "恭喜你，本章节学习完成",
          tips: _vm.tips,
          visible: _vm.isDialogVisible,
          iconPosition: "center",
          showCancelBtn: false,
          showConfirmCzBtn: true,
          showConfirmNextBtn: _vm.showNextBtn,
          confirmNextText: _vm.isGoToExam ? "去考试" : "下一节",
          showConfirmBtn: _vm.showConfirmBtn,
          confirmText: _vm.btnText,
        },
        on: {
          "update:visible": function ($event) {
            _vm.isDialogVisible = $event
          },
          confirm: _vm.go,
          confirmCz: _vm.btnTextCz,
          confirmNext: _vm.confirmNext,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }